import { FormControlLabel, Stack, Switch } from "@mui/material";
import { toggleLiveMode } from "developer/edit/store/toolbar";
import { ChangeEvent, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "store/hooks";
import MoreActions from "./MoreActions";

const VisualEditorActions = () => {
  const dispatch = useAppDispatch();

  const { editorMode } = useAppSelector(
    (state) => state.developer.edit.toolbar
  );

  const handleToggleIsLive = useCallback(
    (event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
      dispatch(toggleLiveMode(checked));
    },
    [dispatch]
  );

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <FormControlLabel
        componentsProps={{ typography: { variant: "caption" } }}
        labelPlacement="start"
        control={
          <Switch
            checked={editorMode.isLive}
            onChange={handleToggleIsLive}
            color="primary"
          />
        }
        label="PREVIEW"
      />
      <MoreActions />
    </Stack>
  );
};

export default VisualEditorActions;
